import Tariff from "../../../utils/services/project/metering/tariffService";
import crudTemplate from "../../../templates/crudTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(Tariff);

const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(i => ({
      ...i,
      _tariff_plan: i._tariff_plan || { id: null },
      tariff_plan_id: (i._tariff_plan && i._tariff_plan.id) || null,
      _tariff_plan_name: (i._tariff_plan && i._tariff_plan.name) || null,
      _tariffable:
        i._tariffable &&
        i._tariffable.instance.name &&
        (i._tariffable.type === "TariffComponent"
          ? i._tariffable.instance.name +
            " (" +
            i18n.t("tariffs.absolute") +
            ")"
          : i._tariffable.instance.type === "factor"
          ? i._tariffable.instance.name + " (" + i18n.t("tariffs.factor") + ")"
          : i._tariffable.instance.type === "relative"
          ? i._tariffable.instance.name +
            " (" +
            i18n.t("tariffs.relative") +
            ")"
          : i._tariffable.instance.type === "absolute"
          ? i._tariffable.instance.name +
            " (" +
            i18n.t("tariffs.absolute") +
            ")"
          : null),
      _tariffable_name: i._tariffable && i._tariffable.instance.name,
      _tariffable_id: i._tariffable && i._tariffable.id,
      _timeframe_name: i._timeframe && i._timeframe.name,
      timeframe_id: i._timeframe && i._timeframe.id,
      _tariffable_group: i._tariffable && i._tariffable.type
    }));
  },
  getItem(state, getters, rootState, rootGetters) {
    let item = crud.getters.getItem(state);
    let project = rootGetters["projectStore/getCurrentItem"];
    item.project_id =
      item._tariff_plan && item._tariff_plan._project
        ? item._tariff_plan._project.id
        : project.id;
    item._tariff_plan = item._tariff_plan || { id: null };
    item.tariff_plan_id = (item._tariff_plan && item._tariff_plan.id) || null;
    item._tariff_plan_name =
      (item._tariff_plan && item._tariff_plan.name) || null;
    item._tariffable_name = item._tariffable && item._tariffable.instance.name;
    item._tariffable_group = item._tariffable && item._tariffable.group;
    item._timeframe = item._timeframe && item._timeframe.value;
    item._tariffable_id = item._tariffable && item._tariffable.id;
    return item;
  }
};

const actions = {
  ...crud.actions,
  async create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item = {
      id: item.id,
      _tariff_plan: { id: item._tariffable_name._tariff_plan.id },
      project_id: item.project_id,
      _component: {
        id:
          item._tariffable_name.group === "Component" ||
          item._tariffable_group === "TariffComponent"
            ? item._tariffable_name.id || item._tariffable_id
            : null
      },
      _modifier: {
        id:
          item._tariffable_name.group === "Modifier" ||
          item._tariffable_group === "TariffModifier"
            ? item._tariffable_name.id || item._tariffable_id
            : null
      },
      _timeframe: { id: item.timeframe_id ? item.timeframe_id.value : null },
      value: item.value,
      valid_from: item.valid_from
    };
    return crud.actions.create(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  },
  async update(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item = {
      id: item.id,
      _tariff_plan: { id: item.tariff_plan_id },
      project_id: item.project_id,
      _component: {
        id:
          item._tariffable_name.group === "Component"
            ? item._tariffable_name.id || item._tariffable_id
            : null
      },
      _modifier: {
        id:
          item._tariffable_name.group === "Modifier"
            ? item._tariffable_name.id || item._tariffable_id
            : null
      },
      _timeframe: {
        id: item.timeframe_id
          ? item.timeframe_id.value || item._timeframe.id
          : null
      },
      value: item.value,
      valid_from: item.valid_from
    };
    return crud.actions.update(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
